<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">子公司内部采购申请</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">

          <purchase-apply ref="apply" :type="0" :userData="userData" :formByFather="form"></purchase-apply>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments ref="attachments" style="margin-left:-10px;" :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item ref="approval" :approvalUsers="approvalUsersData" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>

          </div>


          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitApply()" class="form-btn" type="success">确认提交采购申请
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  import approvalUsers from '@/Mixins/approvalUsers'
  // import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  import Attachments from '@/components/Attachments'
  import ApprovalItem from '@/components/ApprovalItem'

  import PurchaseApply from '@/page/form/purchase/applySubsidiary'
  export default {
    components: {
      ApprovalItem,
      PurchaseApply,
      ApprovalItem,
      Attachments,
    },
    mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        depId: "",
        formLoading: false,
        form: {
          // 0: 集团 1：子公司 2：子公司内部采购
          type: 2,
          name: '',
          zbfs: '',
          price: '',
          leaderId: '',
          depId: '',
          purchaseItems: [],
          json: true,

          projectIds: [],
          projectNames: "",
          reason: "",

          ghdw: "",
          ghqx: "",
          htbh: "",
          htzj: "",
          bccgpc: "",
          bccgj: "",
          yjcgh: "",
          zbccgzj: "",
        },
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
      }

      this.approvalUsersData = this.approvalUsers['c70_' + this.form.type]
      this.getApplyData()
    },
    methods: {
      // 获取审批表原内容
      getApplyData() {
        this.hasApplyId = this.form.applyId ? true : false
        if (this.form.applyId) {
          this.formLoading = true
          this.getProjectApplyInfo()
        } else {
          this.setSelectArr(this.applyInfo, 70, this.form.type / 1)
        }
      },
      // 获取原审批表内容
      getProjectApplyInfo() {
        ajax.get('/purchase/apply/info/' + this.form.applyId, '', (res) => {
          this.applyInfo = res.vo
          this.form = res.vo
          // this.selectArr = this.form.flow.approvals.map(item => item.user)
          this.form.applyId = this.form.flow.applyId
          this.form.json = true

          if (this.form.projectIds) {
            this.form.projectIds = this.form.projectIds.split(",").map(Number)
          } else {
            this.form.projectIds = []
          }

          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []
          this.setSelectArr(this.applyInfo, 70, this.form.type / 1)
          this.formLoading = false
        })
      },
      // 提交使用采购申请单
      SubmitApply() {
        this.form = this.$refs.apply.getFromData()
        this.form.projectIds = this.form.projectIds ? this.form.projectIds.join(",") : ''

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }
        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        let _url = !this.form.applyId ? '/purchase/apply/add' : '/purchase/apply/edit?applyId=' + this.form
          .applyId

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.applyId) {
            this.$message.success("提交采购申请成功，请耐心等待领导审批")
          } else {
            this.$message.success("修改采购申请成功，请耐心等待领导审批")
          }
          this.$router.push('/Purchase/ListSub')
        }, (res) => {
          this.formLoading = false
        })
      },
    },
    watch: {
      'form.type'() {
        this.approvalUsersData = this.approvalUsers['c70_' + this.form.type]
        this.setSelectArr(this.applyInfo, 70, this.form.type / 1)
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/purchase/purchaseApplySub.vue